module.exports = __webpack_public_path__ + "static/img/servcie-banner1.bebbc22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/servcie-banner1.jpg
// module id = v8xY
// module chunks = 32